import { render, staticRenderFns } from "./NextOfKin.vue?vue&type=template&id=d9c72d72"
import script from "./NextOfKin.vue?vue&type=script&lang=js"
export * from "./NextOfKin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports